import { RootState } from '../../../../init-store';

export const selectPermissionsExtendedMatrix = (state: RootState) => state.permissionsExtended.matrix;

export const selectPermissionsExtendedMatrixOverride = (state: RootState) => state.permissionsExtended.matrixOverride;

export const selectPermissionsExtendedStatus = (state: RootState) => state.permissionsExtended.status;

export const selectPermissionExtendedPresetId = (state: RootState) => state.permissionsExtended.presetId;

export const selectNonConfigurablePermissions = (state: RootState) =>
    state.permissionsExtended.nonConfigurablePermissions;

export const selectPermissionsExtendedHaveChangedFromDefault = (state: RootState) =>
    state.permissionsExtended.haveChangedFromDefault;
